// helpers
import { isBusinessLineRegular, isBusinessLineDineout, isCategoryInstamart, isBusinessLineDash } from "./Misc";

// internal-deps
import {
    PaymentMethod,
    PaymentMethodMeta,
    PaymentGroupData,
    PaymentGroupMeta,
    IPreferredPaymentGroup,
} from "@swiggy-private/payment-ui";
import { VALID_PAYMENT_GROUP_TYPES } from "@swiggy-private/payment-core";

// interfaces
import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

export const getPaymentPageOfferEnabledVal = (paymentData?: GetPaymentMethodsResponse | null): boolean => {
    return (
        (isBusinessLineRegular() || isBusinessLineDineout() || (isBusinessLineDash() && isCategoryInstamart())) &&
        !!paymentData?.paymentPageOfferEnabled
    );
};

export function isOtherPaymentOffersGroup(
    group: PaymentGroupData<PaymentGroupMeta, PaymentMethod<PaymentMethodMeta>>,
): group is IPreferredPaymentGroup["paymentData"] {
    return group.groupName.toUpperCase() === VALID_PAYMENT_GROUP_TYPES.EXTRA_OFFERS;
}
